import React from "react";
import {useRestaurant} from "../lib/state.ts";

const RestaurantLongDescription: React.FC = () => {
    const {restaurant} = useRestaurant();

    const formatLongDescription = (description: string) => {
        return description.split('\n').map((paragraph, index) => (
            <p key={index} style={{ margin: '8px 0', lineHeight: '1.4' }}>
                {paragraph.trim()}
            </p>
        ));
    };

    if (!restaurant?.long_description) {
        return null;
    }

    return (
        <div style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
            {formatLongDescription(restaurant.long_description)}
        </div>
    );
};

export default RestaurantLongDescription;
